module.exports = __webpack_public_path__ + "static/media/categories_step_2_1.0b3abdd5.svg";